import { getSearchListQuery } from "../utils/utils";
import { get, post } from "./http.service";

const propertyRollUpService = {
  searchPropertyRollUp: query => get(`propertyRollUp/search${getSearchListQuery(query)}`),
  suggestions: keyword => get(`propertyRollUp/suggestion?keyword=${keyword}`),
  createPropertyRollUp: body => post(`propertyRollUp`, body),
};
export default propertyRollUpService;
